// extracted by mini-css-extract-plugin
export default {"textInfo":"TextInfo_textInfo__FvMpN"};